<template>
  <div>
    <div class="row mb-2">
      <div class="col-12">
        <h4 class="mb-3 text-center">Overview of PSC inspection by country by year</h4>
      </div>
      <div class="col-1 text-left">
        <label for="month" class="col-form-label">YEAR</label>
      </div>
      <div class="col-2">
        <select name="month" id="month" class="form-control form-control-sm" v-model="params.year">
          <option :value="null">--- SELECT YEAR ---</option>
          <option :value="year" v-for="year in years">{{year}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table text-center table-sm small e-tbl">
          <thead class="bg-white">
          <tr>
            <th class="align-middle" scope="col">Year</th>
            <th class="align-middle" scope="col">Country</th>
            <th class="align-middle" scope="col">Nbr Inspection</th>
            <th class="align-middle" scope="col">Deficiency Inspection</th>
            <th class="align-middle" scope="col">No Deficiency Inspection</th>
            <th class="align-middle" scope="col">NDR (%)</th>
            <th class="align-middle" scope="col">Total No. of Deficiency</th>
            <th class="align-middle" scope="col">Ave. Deficiency / Inspection (%)</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="loading">
            <tr>
              <td colspan="100%">
                <app-loading></app-loading>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="report in newInspectionByCountry ">
              <td>{{params.year}}</td>
              <td>{{report.country}}</td>
              <td>{{ report.inspection_count }}</td>
              <td>
                <template v-if="report.with_deficiency_count > 0">
                  <a href="javascript:void(0);" @click="viewPscReports(report, true)">
                    {{report.with_deficiency_count}}
                  </a>
                </template>
                <template v-else>
                  {{report.with_deficiency_count}}
                </template>
              </td>
              <td>
                <template v-if="report.no_deficiency_count > 0">
                  <a href="javascript:void(0);" @click="viewPscReports(report)">
                    {{report.no_deficiency_count}}
                  </a>
                </template>
                <template v-else>
                  {{report.no_deficiency_count}}
                </template>
              </td>
              <td>{{report.no_deficiency_rate}}</td>
              <td>
                <template v-if="report.with_deficiency_count > 0">
                  <a href="javascript:void(0);" @click="viewPscReports(report, true, true)">
                    {{ report.total_deficiency_count }}
                  </a>
                </template>
                <template v-else>
                  {{ report.total_deficiency_count }}
                </template>
              </td>
              <td>{{ report.avg_deficiency_per_inspection }}</td>
            </tr>
          </template>

          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" id="psc_inspection_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase">{{ requestForModal.country_name }} ({{ requestForModal.with_deficiency === 1 ? 'With Deficiency' : 'Without Deficiency' }})</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" :disabled="modalLoading">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive">
                <table class="small e-tbl">
                  <thead class="bg-white text-center" style="position: sticky; top: 0; z-index: 2">
                  <tr>
                    <th class="align-middle" scope="col">#</th>
                    <th class="align-middle" scope="col">VESSEL</th>
                    <th class="align-middle" scope="col">MANAGEMENT OFFICE</th>
                    <th class="align-middle" style="min-width: 25em" scope="col">REPORT TITLE</th>
                    <th class="align-middle" style="width: 5em" scope="col">STATUS</th>
                    <th class="align-middle" style="width: 7em" scope="col">COUNTRY</th>
                    <th class="align-middle" style="width: 10em" scope="col">PORT</th>
                    <th class="align-middle" style="min-width: 9em" scope="col">INSPECTION DATE</th>
                    <th class="align-middle" style="min-width: 9em" scope="col">ACTION</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="modalLoading">
                    <tr class="text-center text-uppercase">
                      <td colspan="100%">
                        <app-loading/>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr class="text-center text-uppercase" v-for="(data, index) in inspectionByCountryReports">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.vessel }}</td>
                      <td>{{ data.managementOffice }}</td>
                      <td>{{ data.title }}</td>
                      <td :class="['bg-'+data.report_status_color]">{{ data.report_status }}</td>
                      <td>{{ data.country }}</td>
                      <td>{{ data.port }}</td>
                      <td>{{ data.inspectionDate }}</td>
                      <td>
                        <button class="m-2 e-btn e-btn-blue e-btn-sm e-text-white"
                                @click="showReportNewTab(data.id)"
                        >
                          <font-awesome-icon icon="eye" />
                          View
                        </button>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="psc_inspection_total_number_of_deficiencies_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase">{{ requestForModal.country_name }} ({{ requestForModal.with_deficiency === 1 ? 'Total No. of Deficiency' : ''}})</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" :disabled="modalLoading">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive" style="max-height: 70vh; overflow-y: auto;">
                <table class="small e-tbl">
                  <thead class="bg-white text-center" style="position: sticky; top: 0; z-index: 2">
                  <tr>
                    <th class="align-middle" scope="col">#</th>
                    <th class="align-middle" scope="col">CODE</th>
                    <th class="align-middle" style="min-width: 25em" scope="col">DESCRIPTION</th>
                    <th class="align-middle" style="min-width: 25em" scope="col">CORRECTIVE ACTION</th>
                    <th class="align-middle" style="min-width: 25em" scope="col">PREVENTIVE MEASURE</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">ACTION CODE</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">VESSEL</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">MANAGEMENT OFFICE</th>
                    <th class="align-middle" style="min-width: 25em" scope="col">REPORT TITLE</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">STATUS</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">COUNTRY</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">PORT</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">INSPECTION DATE</th>
                    <th class="align-middle" style="min-width: 10em" scope="col">ACTION</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="modalLoading">
                    <tr class="text-center text-uppercase">
                      <td colspan="100%">
                        <app-loading/>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr class="text-center" v-for="data in allDeficiencies" :key="data.deficiencyId">

                      <td>{{ data.deficiencyIndex }}</td>
                      <td>{{ data.code }}</td>
                      <td class="text-center" style="white-space: normal;">{{ data.description }}</td>

                      <td class="text-center align-center" style="white-space: normal; min-width: 25em;">
                        <div v-if="isCorrectiveActionExpanded(data.deficiencyId)" v-html="data.correctiveAction.fullHtml"></div>
                        <div v-else>
                          {{ data.correctiveAction.truncatedText }}
                        </div>
                        <a href="javascript:void(0);"
                           v-if="data.correctiveAction.isLong"
                           @click="toggleCorrectiveAction(data.deficiencyId)"
                           style="font-size: 0.75rem;">
                          {{ isCorrectiveActionExpanded(data.deficiencyId) ? 'Show Less' : 'See More' }}
                        </a>
                      </td>

                      <td class="text-center align center" style="white-space: normal; min-width: 25em;">
                        <div v-if="isPreventiveMeasureExpanded(data.deficiencyId)" v-html="data.preventiveMeasure.fullHtml"></div>
                        <div v-else>
                          {{ data.preventiveMeasure.truncatedText }}
                        </div>
                        <a href="javascript:void(0);"
                           v-if="data.preventiveMeasure.isLong"
                           @click="togglePreventiveMeasure(data.deficiencyId)"
                           style="font-size: 0.75rem;">
                          {{ isPreventiveMeasureExpanded(data.deficiencyId) ? 'Show Less' : 'See More' }}
                        </a>
                      </td>

                      <td class="align-center">{{ data.actionCode }}</td>

                      <template v-if="data.isFirstInGroup">
                        <td class="align-center text-uppercase" :rowspan="data.groupRowspan">{{ data.vessel }}</td>
                        <td class="align-center text-uppercase text-uppercase" :rowspan="data.groupRowspan">{{ data.managementOffice }}</td>
                        <td class="align-center text-center text-uppercase" :rowspan="data.groupRowspan" style="white-space: normal;">{{ data.title }}</td>
                        <td class="align-center text-uppercase" :rowspan="data.groupRowspan" :class="['bg-'+data.report_status_color]">{{ data.report_status }}</td>
                        <td class="align-center text-uppercase" :rowspan="data.groupRowspan">{{ data.country }}</td>
                        <td class="align-center text-uppercase" :rowspan="data.groupRowspan">{{ data.port }}</td>
                        <td class="align-center text-uppercase" :rowspan="data.groupRowspan">{{ data.inspectionDate }}</td>
                        <td class="align-center text-uppercase" :rowspan="data.groupRowspan">
                          <button class="m-2 e-btn e-btn-blue e-btn-sm e-text-white"
                                  @click="showReportNewTab(data.reportId)" >
                            <font-awesome-icon icon="eye" />
                            View
                          </button>
                        </td>
                      </template>

                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";
import _ from "lodash"

export default {
  name: "PscInspectionByCountry",
  components: {AppLoading},
  data(){
    return {
      loading:false,
      params:{
        year:new Date().getFullYear(),
      },
      years:Array.from({length:100},(_,i)=>new Date().getFullYear() - i),
      requestForModal : {
        year : null,
        country_id : null,
        with_deficiency : 1,
        country_name : '',
      },
      modalLoading: false,

      expandedCorrectiveActions: [],
      expandedPreventiveMeasures: []
    }
  },
  computed:{
    ...mapGetters(['inspectionByCountry', 'inspectionByCountryReports', '']),
    allDeficiencies() {
      const processActionText = (htmlArray) => {
        if (!htmlArray || htmlArray.length === 0) {
          return { fullHtml: '', plainText: '', isLong: false, truncatedText: '' };
        }

        const fullHtml = htmlArray.join(' ');

        const el = document.createElement('div');
        el.innerHTML = fullHtml;

        const plainText = (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();

        const isLong = plainText.length > 200;
        const truncatedText = isLong ? plainText.substring(0, 200) + '...' : plainText;

        return { fullHtml, plainText, isLong, truncatedText };
      };

      const flatList = [];
      let deficiencyCounter = 0;

      if (!this.inspectionByCountryReports) {
        return [];
      }

      this.inspectionByCountryReports.forEach(report => {

        if (report.deficiencies && report.deficiencies.length > 0) {

          const groupRowspan = report.deficiencies.length;

          report.deficiencies.forEach((deficiency, defIndex) => {

            deficiencyCounter++;

            const processedCorrective = processActionText(deficiency.corrective_actions);
            const processedPreventive = processActionText(deficiency.preventative_measures);

            flatList.push({
              deficiencyId: deficiency.id,
              code: deficiency.code,
              description: deficiency.description,
              rootCause: deficiency.rootCause,

              preventiveMeasure: processedPreventive,
              correctiveAction: processedCorrective,

              actionCode: deficiency.actionCode,

              reportId: report.id,
              vessel: report.vessel,
              managementOffice: report.managementOffice,
              title: report.title,
              report_status: report.report_status,
              report_status_color: report.report_status_color,
              country: report.country,
              port: report.port,
              inspectionDate: report.inspectionDate,

              deficiencyIndex: deficiencyCounter,

              isFirstInGroup: defIndex === 0,

              groupRowspan: groupRowspan
            });
          });
        }
      });

      return flatList;
    },

    newInspectionByCountry() {
      if (this.params.year === null) {
        return [];
      }
      return this.inspectionByCountry;
    },
    noOfDeficiency() {
      return _.sum(this.newInspectionByCountry.map(item => item.no_deficiency_count));
    }
  },
  methods:{
    ...mapActions([
      'getInspectionReportByCountry',
      'getInspectionReportByCountryReports'
    ]),
    async getData(){
      this.loading=true
      await this.getInspectionReportByCountry(this.params)
      this.loading=false
    },
    async viewPscReports(report, withDeficiency = false, totalNumberOfDeficiency = false) {
      this.modalLoading = true;
      this.expandedCorrectiveActions = [];
      this.expandedPreventiveMeasures = [];

      if (totalNumberOfDeficiency === true) {
        $('#psc_inspection_total_number_of_deficiencies_modal').modal('show');
      } else {
        $('#psc_inspection_modal').modal('show');
      }
      this.requestForModal = {
        year : this.params.year,
        country_id : report.country_id,
        country_name : report.country,
        with_deficiency : withDeficiency === true ? 1 : 0,
        perPage : 10000
      }
      await this.getInspectionReportByCountryReports(this.requestForModal);
      this.modalLoading = false;
    },
    async showReportNewTab (reportId) {
      const route= this.$router.resolve(
        {
          name: 'PscDeficiency',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    /**
     * Toggles the expanded state for a corrective action.
     * @param {number} deficiencyId
     */
    toggleCorrectiveAction(deficiencyId) {
      const index = this.expandedCorrectiveActions.indexOf(deficiencyId);
      if (index > -1) {
        this.expandedCorrectiveActions.splice(index, 1); // Collapse
      } else {
        this.expandedCorrectiveActions.push(deficiencyId); // Expand
      }
    },

    /**
     * Checks if a corrective action is expanded.
     * @param {number} deficiencyId
     * @returns {boolean}
     */
    isCorrectiveActionExpanded(deficiencyId) {
      return this.expandedCorrectiveActions.includes(deficiencyId);
    },
    togglePreventiveMeasure(deficiencyId) {
      const index = this.expandedPreventiveMeasures.indexOf(deficiencyId);
      if (index > -1) {
        this.expandedPreventiveMeasures.splice(index, 1); // Collapse
      } else {
        this.expandedPreventiveMeasures.push(deficiencyId); // Expand
      }
    },
    isPreventiveMeasureExpanded(deficiencyId) {
      return this.expandedPreventiveMeasures.includes(deficiencyId);
    }
  },
  created(){
    this.getInspectionByCountry=_.debounce(this.getData,250)
    this.getData()
  },

  watch:{
    "params.year"(){
      if (this.params.year !== null) {
        this.getInspectionByCountry()
      }
    }
  }

}
</script>


<style scoped>
.e-tbl thead tr th {
  border: 1px solid #b1b1b1;
}

</style>
